/* global angular */
( function () {
	'use strict';

	var timer = [ { }, { } ];
	var up    = 0;
	var down  = 1;

	function scroll ( container, increments, speed, interval, direction ) {
		interval.cancel( timer[ direction ] );
		timer[ direction ] = { };

		var invert = ( direction + 1 ) % 2;

		if ( !Object.keys( timer[ invert ] ).length ) {
			timer[ invert ] = interval( function () {
				container.scrollTop += increments;
			}, speed );
		}
	}

	function clearIntervals ( interval ) {
		interval.cancel( timer[ down ] );
		interval.cancel( timer[ up ] );
		timer = [ { }, { } ];
	}

	function reorderContentLink ( scope ) {
		var self = this;

		scope.indicatorDragControl = {
			'accept' : function ( sourceItemHandleScope ) {
				return !sourceItemHandleScope.itemScope.modelValue.indicators;
			},

			'dragMove' : function ( itemPosition, containment, eventObj ) {
				var container  = document.getElementById( 'dragdrop-container' );
				var upperLimit = container.getBoundingClientRect().top;
				var lowerLimit = upperLimit + container.clientHeight;
				var maxScroll  = container.scrollHeight - container.clientHeight;

				var dragElem = document.getElementsByClassName( 'as-sortable-dragging' )[ 0 ];

				var grabbedItem = {
					'element' : dragElem,
					'top'     : eventObj.pageY,
					'bottom'  : eventObj.pageY + ( dragElem || {} ).clientHeight
				};

				if ( grabbedItem.top <= upperLimit && container.scrollTop > 0 ) {
					scroll( container, -5, 20, self.interval, down );
				} else if ( grabbedItem.bottom >= lowerLimit && container.scrollTop < maxScroll ) {
					scroll( container, 5, 20, self.interval, up );
				} else {
					clearIntervals( self.interval );
				}
			},

			'dragEnd' : function ( options ) {
				var srcIndex   = options.source.sortableScope.element[ 0 ].dataset.gIndex;
				var destIndex  = options.dest.sortableScope.element[ 0 ].dataset.gIndex;
				var formula    = ( scope.vm.model.groups[ srcIndex ] || {} ).formula || '';
				var itemId     = options.source.itemScope.modelValue.id;

				if ( formula.indexOf( itemId ) > -1 && srcIndex !== destIndex ) {
					options.dest.sortableScope.removeItem( options.dest.index );
					options.source.itemScope.sortableScope.insertItem( options.source.index, options.source.itemScope.modelValue );
					self.logger.notifyError( self.indicatorDeleteError );
				}

				clearIntervals( self.interval );
				scope.vm.isMoving = false;
			},

			'clone' : false
		};

		scope.groupDragControls = angular.copy( scope.indicatorDragControl );

		scope.groupDragControls.additionalPlaceholderClass = 'group-placeholder';

		scope.groupDragControls.accept = function ( sihs, dss ) {
			return !scope.indicatorDragControl.accept( sihs, dss );
		};
	}

	function reorderContent ( $interval, ERROR_MSGS, logger ) {
		return {
			'templateUrl'      : '/templates/templates-new/reorder/drag-and-drop/drag-and-drop.html',
			'restrict'         : 'E',
			'replace'          : true,
			'controller'       : 'DragController',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'link'             : reorderContentLink.bind( {
				'interval'             : $interval,
				'indicatorDeleteError' : ERROR_MSGS.indicatorDeleteError,
				'logger'               : logger
			} ),

			'scope' : {
				'model'          : '=',
				'isSaving'       : '=',
				'isMoving'       : '=',
				'focusGroup'     : '=',
				'focusIndicator' : '=',
				'reset'          : '='
			}
		};
	}

	reorderContent.$inject = [ '$interval', 'ERROR_MSGS', 'logger' ];

	angular.module( 'app.templates' )
		.directive( 'reorderContent', reorderContent );
} )();
